import 'flexslider';

(function ($, root, undefined) {


	$(function () {

		'use strict';

        $(".navbar-burger").click(function() {

            // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
            $(".navbar-burger").toggleClass("is-active");
            $(".navbar-menu").toggleClass("is-active");

        });
        var $status = $('.pagingInfo1');
        var $slickElement = $('#testimony_carroussel');

        $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });

        // var $status2 = $('.pagingInfo2');
        // var $slickElement2 = $('#carouselright');

        // $slickElement2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //     var i = (currentSlide ? currentSlide : 0) + 1;
        //     $status2.text(i + '/' + slick.slideCount);
        // });


        $('.carousel').slick({
            // dots: true,
        });
        $('.accordion').find('.accordion-toggle').click(function(){
            $(this).next().slideToggle('fast');
            $(".accordion-content").not($(this).next()).slideUp('fast');
            $(this).toggleClass("active").siblings().removeClass("active");

          });

          // Menu responsive

          $(".mobile-menu .menu-item-has-children").prepend('<div class="cross"></div>');

          $('.mobile-menu').find('.menu-item-has-children').click(function(){
            $(this).toggleClass("active").siblings().removeClass("active");

          });

          // SEE MORE Section 5
         if ($('.vignette').length > 6){
            $(".section5__see-more-btn").addClass("showMore");
            $( ".section5__see-more-btn" ).click(function() {
                var elem = $(".section5__see-more-btn p").text();

                if (elem == "Afficher plus") {
                  //Stuff to do when btn is in the read more state
                  $(".section5__see-more-btn p").text("Afficher moins");
                  $(".section5").addClass("maxheightAll");
                } else if (elem == "See more") {
                    //Stuff to do when btn is in the read more state
                    $(".section5__see-more-btn p").text("See less");
                    $(".section5").addClass("maxheightAll");
                  } else {
                  //Stuff to do when btn is in the read less state
                  if (elem == "Afficher moins") {
                  $(".section5__see-more-btn p").text("Afficher plus");
                  }else {
                    $(".section5__see-more-btn p").text("See more");
                  }
                  $(".section5").removeClass("maxheightAll");
                }
              });
            };

            $('.documentation_pagination:has(span)').addClass('showPag');
		
		
		var shown_menu = [];
		$('.show-navmobile').click(function(e){
			e.preventDefault();
			$('.navbar-mobile-popup').addClass('show');
		});
		
		$('.hide-navmobile').click(function(e){
			e.preventDefault();
			$('.navbar-mobile-popup').removeClass('show');
			shown_menu = [];
			refresh_navback();
		});
		$('.mobile-navigation .menu-item-has-children > a').click(function(e){
			e.preventDefault();
			e.stopPropagation();
			let par = $(this).closest("li");
			let targ_el = par.find('> .sub-menu');
			targ_el.addClass('show')
			shown_menu.push({
				title: $(this).text(),
				ctrl: targ_el
			});
			refresh_navback();
		});
		$('.back-navmobile').click(function(e){
			e.preventDefault();
			if (shown_menu.length){
				
				shown_menu[shown_menu.length-1].ctrl.removeClass('show');
				shown_menu.pop();
				refresh_navback();
			}
		});
		function refresh_navback(){
			if (shown_menu.length){
				$('.back-navmobile').addClass('show');
				$('.ntb-middle-text').html(shown_menu[shown_menu.length-1].title);
				
			}else{
				
				$('.mobile-navigation .sub-menu.show').removeClass('show');
				$('.back-navmobile').removeClass('show');
				$('.ntb-middle-text').html("MENU");
			}
		}
		
		const el = document.querySelector(".pincheck")
		const observer = new IntersectionObserver( 
		  function([e]){ 
			if  (e.intersectionRatio < .9){
				$(".navbar-container").addClass("is-pinned")
			}else{
				$(".navbar-container").removeClass("is-pinned")
			}
		  },
		  { threshold: [  .9, 1 ] }
		);

		observer.observe(el);
		
		let logmenu;
		$('#menu-item-2745').on("mouseenter", function(){
			logmenu = $(this).find("> a").text();
			 $(this).find("> a").text("BIENVENUE CYCLISTES!");
		});
		$('#menu-item-2745').on("mouseleave", function(){
			 $(this).find("> a").text(logmenu);
		});
		
		$('#menu-item-2829').on("mouseenter", function(){
			logmenu = $(this).find("> a").text();
			 $(this).find("> a").text("BIENVENUE CYCLISTES!");
		});
		
		$('#menu-item-2829').on("mouseleave", function(){
			 $(this).find("> a").text(logmenu);
		});
		
		$('.close-alert').on("click", function(ev){
			ev.preventDefault();
			 $('.alert-container').addClass("hide-alert");
			 $.ajax({
				url: adminajax_url,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'hide_alert',
				}
			}).done(function(data){
			
			});
			
			 setTimeout(function(){
				 $('.alert-container').remove();
				 calc_crh();
				 if( $('.carte-routeverte').length ){
					 let targetSrc =  $('.carte-routeverte iframe').attr('src');
					 $('.carte-routeverte iframe').attr('src', targetSrc);
				 }
			 }, 310);
		});
		
		$('.flexslider').flexslider({
			animation: "slide",
			controlsContainer: $(".dot-wrap"),
			customDirectionNav: $(".lctrl")
		});
		$('.back-link').click(function(e){
			e.preventDefault();
			history.back();
		
		})
		$.protip();
    });
	
	window.show_guide = function(){
		$('.grid-preview').css("display", "grid");
		$('.grid-preview').css("height", $('.content_page').height());
		
		
	}
	
	
	$( window ).on( "resize", calc_crh );
	$( document ).ready(function(){
		calc_crh();
		setTimeout(function(){
			calc_crh();
		}, 1000);
		
	});
	function calc_crh(){
		if( $('.carte-routeverte').length ){
			let alert_h = 0;
			let menu_h = 0;
			let window_h = $(window).height();

			if( $('.alert-container').length ){
				alert_h = $('.alert-container').height();
			}
			menu_h = $('.navbar-container').height()
			let cr_h = window_h - ( menu_h + alert_h );
			$('.carte-routeverte').height( cr_h )
			$('.carte-routeverte').css( "top", ( menu_h + alert_h ) + "px" );
		}
	}
	
})(jQuery, this);


 
var tooltips = document.querySelectorAll('.tooltip span');

window.onmousemove = function (e) {
    var x = (e.clientX + 20) + 'px',
        y = (e.clientY + 20) + 'px';
    for (var i = 0; i < tooltips.length; i++) {
        tooltips[i].style.top = y;
        tooltips[i].style.left = x;
    }
};



/*

*/


// WEBPACK FOOTER //
// ./assets/js/theme.js